import { useIsMobile } from '@common/hooks/useIsMobile';
import { SidebarProvider } from '@ntconsult/aluma-react';
import { useUIStore } from '@store/uiStore';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { AppHeader } from './AppHeader';
import { AppSidebar } from './AppSidebar';

export function Layout() {
  const sidebarOpen = useUIStore((s) => s.sidebarOpen);
  const setSidebarOpen = useUIStore((s) => s.setSidebarOpen);
  const isMobile = useIsMobile();
  // Em mobile a sidebar vira overlay (off-canvas) que começa fechado e tem
  // estado próprio — não mexe na preferência persistida de colapso do desktop.
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <SidebarProvider
      collapsible={isMobile ? 'offcanvas' : 'icon'}
      open={isMobile ? mobileOpen : sidebarOpen}
      onOpenChange={isMobile ? setMobileOpen : setSidebarOpen}
    >
      <div className="flex h-dvh w-full">
        <AppSidebar />
        <div className="flex min-w-0 flex-1 flex-col">
          <AppHeader />
          <main className="min-h-0 flex-1 overflow-y-auto px-4 py-6 sm:px-gutter sm:py-page">
            <Outlet />
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}
